// extracted by mini-css-extract-plugin
export default {"root":"_2SGth","gift-icon":"bRMeJ","giftIcon":"bRMeJ"};